// event-bus.js
import Vue from 'vue'
export const EventBus = new Vue()

export const Events = {
  HLS_STARTING: 'HLS_STARTING',
  HLS_NETWORK_ERROR: 'HLS_NETWORK_ERROR'
}